var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex justify-between items-end"},[(_vm.isNotSubChild)?_c('sub-menu',{attrs:{"title":_vm.title,"routes":_vm.routes}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }